import React from 'react'


const PatientIcon = ({ active }) => {
    return (
        
        <svg className={`svg-icon ${active}`} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
            viewBox="20 10 25 30" >

            <path className="color " d="M29.2,24.7c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2C30.4,25.3,29.9,24.7,29.2,24.7
                z M35.2,24.7c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.6,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2C36.4,25.3,35.9,24.7,35.2,24.7z M32.2,15
                c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S37.7,15,32.2,15z M32.2,33c-4.4,0-8-3.6-8-8c0-0.3,0-0.6,0.1-0.9
                c2.4-1,4.2-3,5.2-5.4c2.3,3.3,6.5,4.9,10.4,4c0.2,0.7,0.3,1.5,0.3,2.3C40.2,29.4,36.6,33,32.2,33z"/>
        </svg>
    )
}

export default PatientIcon


// WEBPACK FOOTER //
// ./src/components/practice_admin/images/PatientIcon.jsx